import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';
import { useEffect, useRef } from 'react';

const useStyles = makeStyles(() => ({
  canvasWrapper: {
    width: '100%',
    height: '100%',
    display: 'block',
  },
}));

const BlackSquareCanvas: React.FC = () => {
  const classes = useStyles();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext('2d');
    if (!context) return;

    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    context.fillStyle = 'black';
    context.fillRect(0, 0, canvas.width, canvas.height);
  }, []);

  return <canvas ref={canvasRef} className={classes.canvasWrapper} />;
};

export default BlackSquareCanvas;
